module.exports = __webpack_public_path__ + "assets/images/ac4bce1a478b59240a2fb37c6a7c31cc.png";